import { combineReducers } from 'redux'
import auth from './auth'
import spaces from './spaces'

export default combineReducers({
  auth,
  spaces
})


// WEBPACK FOOTER //
// ./src/reducers/index.js